import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaShieldAlt, FaCrosshairs, FaGraduationCap, FaArrowRight, FaExternalLinkAlt,
} from 'react-icons/fa';
import { motion } from 'motion/react';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import ScrollReveal from './ScrollReveal';
import { productCategories } from '../config/productsMenuConfig';
import { getRevealProps, staggerContainer, staggerItem, defaultViewport } from '../motion/scrollMotion';
import './ContentPages.css';

const iconMap = {
  shield: <FaShieldAlt />,
  crosshairs: <FaCrosshairs />,
  graduation: <FaGraduationCap />,
};

const ProductsPage = () => (
  <div className="content-page">
    <PageNavbar />

    <section className="content-hero">
      <div className="content-hero-background" />
      <div className="content-hero-stars" />
      <ScrollReveal className="content-hero-inner" animateOnMount variant="fadeUp">
        <span className="content-badge">Products</span>
        <h1 className="content-hero-title">
          The <span className="content-accent">Trinex360</span> Product Suite.
        </h1>
        <p className="content-hero-desc">
          Security software built by our own team — from a managed 24/7 SOC to continuous external
          exposure monitoring and enterprise security-awareness training. Each product is focused,
          and plugs straight into your security program.
        </p>
      </ScrollReveal>
    </section>

    {productCategories.map((cat, ci) => (
      <section key={cat.title} className={`content-section ${ci % 2 === 1 ? 'alt' : ''}`}>
        <div className="content-container">
          <motion.div className="content-section-header" {...getRevealProps('fadeUp')}>
            <span className="content-section-tag">{cat.tag}</span>
            <h2 className="content-section-title">{cat.title}</h2>
            <p className="content-section-subtitle">{cat.blurb}</p>
          </motion.div>

          <motion.div
            className="content-grid"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={defaultViewport}
          >
            {cat.items.map((product) => (
              <motion.div key={product.slug} className="content-card" variants={staggerItem}>
                <div className="content-card-icon">{iconMap[product.icon]}</div>
                <div className="content-meta">
                  {product.status === 'preview' ? 'In preview' : 'Available now'}
                </div>
                <h3 className="content-card-title">{product.label}</h3>
                <p className="content-card-desc">{product.menuDesc}</p>
                <div className="product-card-links">
                  <Link to={product.href} className="content-card-link">
                    Explore {product.label} <FaArrowRight />
                  </Link>
                  {product.external && (
                    <a
                      href={product.external.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="content-card-link"
                    >
                      {product.external.label} <FaExternalLinkAlt />
                    </a>
                  )}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    ))}

    <Footer />
  </div>
);

export default ProductsPage;
